module.exports = __webpack_public_path__ + "08f58f7678b545de5960f4ed80d37158.ttf";